module.exports = __webpack_public_path__ + "static/media/tap-01@2x.b506776a.png";